module.exports = __webpack_public_path__ + "media/images/lig/products/lig-product-07-b7d398152814914d54c61172f4075f9f.jpg";